import { Link } from "@tanstack/react-router";

export function SiteFooter() {
  return (
    <footer className="mt-32 border-t border-hairline bg-background">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="font-serif text-3xl tracking-[0.4em]">HOWDEN</div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-muted-foreground">
              Lab-grown diamond jewelry, hand-made by master craftspeople from
              ateliers around the world.
            </p>
          </div>
          <div>
            <h2 className="text-xs uppercase tracking-luxe text-muted-foreground">
              House
            </h2>
            <ul className="mt-6 space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-accent-foreground">About</Link></li>
              <li><Link to="/shop" className="hover:text-accent-foreground">Collection</Link></li>
              <li><Link to="/bespoke" className="hover:text-accent-foreground">Bespoke</Link></li>
              <li><Link to="/contact" className="hover:text-accent-foreground">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="text-xs uppercase tracking-luxe text-muted-foreground">
              Knowledge
            </h2>
            <ul className="mt-6 space-y-3 text-sm">
              <li><Link to="/knowledge-base" hash="the-4cs" className="hover:text-accent-foreground">The 4Cs</Link></li>
              <li><Link to="/knowledge-base" hash="how-grown" className="hover:text-accent-foreground">How They're Grown</Link></li>
              <li><Link to="/knowledge-base" hash="choosing-shape" className="hover:text-accent-foreground">Choosing a Shape</Link></li>
              <li><Link to="/faq" className="hover:text-accent-foreground">FAQ</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-hairline pt-8 text-xs uppercase tracking-luxe text-muted-foreground sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} Howden Diamonds</span>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/privacy" className="hover:text-accent-foreground">Privacy</Link>
            <Link to="/data-handling" className="hover:text-accent-foreground">Data Handling</Link>
            <span>Lab-grown · Hand-made · IGI / GIA</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
